{
  "status": {
    "POSTED": "Posted",
    "VOID": "Void"
  },
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "You have changes on this page that haven't been saved.",
    "confirm": "Discard changes",
    "cancel": "Keep editing"
  },
  "errors": {
    "INSUFFICIENT_FUNDS": "There isn't enough money in this account on that date. Lower the amount or choose another account.",
    "ACCOUNT_NOT_EMPTY": "This account still holds money. Move the balance out before archiving it.",
    "ACCOUNT_ARCHIVED": "An archived account can't be used. Choose an active one.",
    "EXPENSE_VOID": "A void expense can't be edited.",
    "SUPPLIER_ARCHIVED": "This supplier is archived. Restore it or choose another.",
    "TRANSFER_DATE_IN_FUTURE": "A transfer can't be dated after today.",
    "INSUFFICIENT_FUNDS_LATER": "The account held enough on that date, but later payments would take it below zero. Lower the amount or choose a later date.",
    "NO_ACCOUNT_CODE": "No free ledger code is left for a new cash or bank account. Ask your accountant to extend the chart.",
    "TILL_DOCUMENT": "This came from the till, so it can only be undone there: void the sale at the till while its shift is open.",
    "ACCOUNT_NOT_EMPTY_accountingOff": "This account still holds money, so it cannot be archived. Accounting is turned off for your company, and the money can be moved out only once it is back on.",
    "ACCOUNT_IN_USE": "Money moves through this account by {{names}}. Give them another account first, then archive it.",
    "ACCOUNT_KIND_IN_USE": "This account can't become that kind: {{names}} use it and would no longer fit. Move them to another account first.",
    "tillNamed": "till {{code}}",
    "defaultFor": "the default account for {{method}}"
  },
  "treasury": {
    "title": "Cash and bank",
    "subtitle": "The business's cash boxes, bank accounts, card terminals and wallets, with today's balances.",
    "new": "New account",
    "newTitle": "New cash or bank account",
    "newSubtitle": "A ledger account is created for it automatically.",
    "editTitle": "Edit account",
    "save": "Save account",
    "actions": "Actions",
    "archived": "Archived",
    "showArchived": "Show archived",
    "total": "Total held",
    "empty": "No cash or bank accounts yet.",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "entriesOf": "Journal entries of {{name}}",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "kind": "Kind",
      "bankDetails": "Bank",
      "bankName": "Bank",
      "accountNumber": "Account number",
      "iban": "IBAN",
      "glAccount": "Ledger account",
      "balance": "Balance",
      "openingBalance": "Opening balance",
      "openingDate": "As of"
    },
    "kind": {
      "CASH": "Cash",
      "BANK": "Bank account",
      "CARD_TERMINAL": "Card terminal",
      "MOBILE_WALLET": "Mobile wallet"
    },
    "opening": {
      "title": "Money already in the account",
      "hint": "Posted against opening balance equity on this date. Leave empty for a new, empty account."
    },
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It can no longer be used for payments or transfers. Only an empty account can be archived.",
      "confirm": "Archive"
    },
    "errors": {
      "nameTaken": "Another account already has this name.",
      "version": "Someone else changed this account. Close this panel and open it again."
    },
    "toast": {
      "created": "{{name}} added",
      "updated": "Account saved",
      "archived": "Account archived"
    }
  },
  "transfers": {
    "title": "Transfers",
    "subtitle": "Money moved between your own cash and bank accounts.",
    "new": "New transfer",
    "newTitle": "New transfer",
    "newSubtitle": "Posted to the ledger straight away.",
    "save": "Transfer",
    "actions": "Actions",
    "chooseAccount": "Choose an account",
    "available": "Available in {{name}}:",
    "after": "After the transfer:",
    "overdrawn": "The amount is more than the account holds today. The transfer is refused if the balance on its date is too low.",
    "voidNamed": "Void {{number}}",
    "fields": {
      "number": "Number",
      "date": "Date",
      "from": "From",
      "to": "To",
      "amount": "Amount",
      "reference": "Reference",
      "notes": "Notes",
      "status": "Status"
    },
    "empty": {
      "title": "No transfers yet.",
      "body": "Record money moved between cash and bank, such as a cash deposit."
    },
    "void": {
      "title": "Void transfer {{number}}?",
      "body": "Its journal entry is reversed and both balances return to what they were.",
      "reason": "Reason",
      "confirm": "Void transfer"
    },
    "toast": {
      "created": "Transfer {{number}} posted",
      "voided": "Transfer {{number}} voided"
    },
    "fromTill": "Till",
    "fromTillHint": "A pay-in or pay-out made at the till, so it can't be voided here."
  },
  "expenses": {
    "title": "Expenses",
    "subtitle": "Money spent: each expense posts to its account and to the cash or bank it was paid from.",
    "new": "New expense",
    "newTitle": "New expense",
    "newSubtitle": "The number is assigned when you save.",
    "editTitle": "Edit {{number}}",
    "editSubtitle": "Edit expense",
    "save": "Save expense",
    "saveHint": "Press {{shortcut}} to save",
    "edit": "Edit",
    "searchLabel": "Search expenses",
    "searchPlaceholder": "Search number, description, payee…",
    "clearSearch": "Clear search",
    "categoryFilter": "Filter by category",
    "allCategories": "All categories",
    "paidFromFilter": "Filter by paying account",
    "allPaidFrom": "All paying accounts",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses",
    "clearFilters": "Clear filters",
    "pageTotals_one": "Posted on this page ({{n}} expense)",
    "pageTotals_other": "Posted on this page ({{n}} expenses)",
    "chooseCategory": "Choose a category",
    "chooseSupplier": "No supplier",
    "clearSupplier": "No supplier",
    "searchCategories": "Search categories…",
    "noCategories": "No categories. Create one under Expenses › Categories.",
    "choosePaidFrom": "Choose the cash or bank account",
    "balance": "Balance today:",
    "postsTo": "Posts to",
    "overridden": "(chosen below)",
    "useDefault": "Category default ({{code}})",
    "useCategoryDefault": "The category's default account",
    "searchAccounts": "Search code or name…",
    "noAccounts": "No expense or asset accounts found.",
    "clearOverride": "Use the category's default",
    "noTax": "No tax",
    "viewEntry": "View journal entry",
    "posted": "Posted",
    "noEntry": "None (voided)",
    "backToExpense": "Back to expense",
    "voidTitle": "This expense is void",
    "voidReason": "Reason: {{reason}}",
    "sections": {
      "what": "Expense",
      "amount": "Amount",
      "payment": "Payment",
      "posting": "Posting",
      "attachments": "Attachments"
    },
    "fields": {
      "number": "Number",
      "date": "Date",
      "category": "Category",
      "description": "Description",
      "payee": "Paid to",
      "supplier": "Supplier",
      "vatin": "Supplier VATIN",
      "reference": "Reference",
      "amount": "Amount before tax",
      "taxRate": "Tax rate",
      "net": "Net",
      "tax": "Tax",
      "total": "Total",
      "paidFrom": "Paid from",
      "account": "Post to a different account",
      "postedTo": "Posted to",
      "journalEntry": "Journal entry",
      "status": "Status",
      "createdAt": "Created",
      "updatedAt": "Last changed"
    },
    "hints": {
      "reference": "The receipt or invoice number, if there is one.",
      "supplier": "The supplier whose tax invoice this is, for the VAT return. Nothing is owed to them.",
      "vatin": "VATIN {{vatin}}",
      "noVatin": "This supplier has no VATIN on file: input VAT is reclaimable only on a tax invoice showing it.",
      "amount": "Tax is added from the rate you choose.",
      "account": "Only when this expense belongs elsewhere than its category's account."
    },
    "errors": {
      "notSaved": "The expense wasn't saved",
      "field": "Check this value."
    },
    "conflict": {
      "title": "Someone else changed this expense",
      "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
      "reload": "Reload latest"
    },
    "empty": {
      "title": "No expenses yet.",
      "body": "Record your first expense: rent, utilities, fuel…",
      "filteredTitle": "No expenses match.",
      "filteredBody": "Try another search or period, or clear the filters."
    },
    "void": {
      "action": "Void",
      "title": "Void expense {{number}}?",
      "body": "Its journal entry is reversed on the expense date, as if it never happened. This can't be undone.",
      "reason": "Reason",
      "confirm": "Void expense"
    },
    "toast": {
      "created": "Expense {{number}} saved",
      "updated": "Expense saved",
      "voided": "Expense {{number}} voided"
    },
    "stats": {
      "label": "Expense figures",
      "spent": "Spent this month",
      "spentDetail": "{{month}} · {{expenses}}",
      "trend": "Posted expenses by month, {{from}} to {{to}}",
      "posted": "Posted",
      "tax": "Input VAT",
      "taxDetail": "On posted expenses",
      "void": "Void",
      "voidDetail": "Reversed, kept on record",
      "expenses_one": "{{n}} expense",
      "expenses_other": "{{n}} expenses"
    },
    "suggest": {
      "action": "Suggest category",
      "prompt": "Suggest the category for this expense.",
      "fromHistory_one": "Chose {{category}}: used for {{n}} earlier expense to {{payee}}, last on {{date}}.",
      "fromHistory_other": "Chose {{category}}: used for {{n}} earlier expenses to {{payee}}, the last on {{date}}.",
      "fromAssistant": "The assistant chose {{category}}.",
      "check": "Check it, then save.",
      "none": "No earlier expenses paid to them. Choose the category yourself.",
      "noneAtAll": "No suggestion this time. Choose the category yourself.",
      "needsInput": "Fill in “Paid to” first: the suggestion comes from earlier expenses paid to them.",
      "needsInputAi": "Fill in “Paid to” or the description first.",
      "failed": "The suggestion couldn’t be made. Choose the category yourself.",
      "sureness": {
        "high": "Very likely",
        "medium": "Likely",
        "low": "Not sure"
      },
      "offerAssistant": "The assistant suggests {{category}}. Use it only if it fits.",
      "use": "Use it",
      "fromRule": "Chose {{category}}."
    }
  },
  "categories": {
    "title": "Expense categories",
    "subtitle": "Kinds of spending, each posting to its default account.",
    "new": "New category",
    "newTitle": "New expense category",
    "newSubtitle": "Name the category and choose where it posts.",
    "editTitle": "Edit expense category",
    "save": "Save category",
    "actions": "Actions",
    "archived": "Archived",
    "showArchived": "Show archived",
    "empty": "No expense categories yet.",
    "chooseAccount": "Choose an account",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "defaultAccount": "Default account"
    },
    "hints": {
      "account": "An expense or asset account (not a cash or bank account). Each expense can override it."
    },
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It can no longer be chosen for new expenses. Existing expenses keep it.",
      "confirm": "Archive"
    },
    "errors": {
      "nameTaken": "A category with this name already exists.",
      "account": "Choose an active expense or asset account, not a cash or bank account nor one kept by documents (inventory, receivables, payables, cheques under collection or issued, contract advances or retention, VAT).",
      "version": "Someone else changed this category. Close this panel and open it again."
    },
    "toast": {
      "created": "Category created",
      "updated": "Category saved",
      "archived": "Category archived"
    }
  },
  "taxRates": {
    "title": "Tax rates",
    "subtitle": "Rates offered on documents and expenses. The default is suggested on new ones.",
    "new": "New tax rate",
    "newTitle": "New tax rate",
    "newSubtitle": "For example VAT 5%.",
    "editTitle": "Edit tax rate",
    "editNotice": "Changing a rate affects new documents only; saved ones keep the rate they were saved with.",
    "save": "Save tax rate",
    "actions": "Actions",
    "default": "Default",
    "archived": "Archived",
    "showArchived": "Show archived",
    "empty": "No tax rates yet.",
    "editNamed": "Edit {{name}}",
    "archiveNamed": "Archive {{name}}",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "rate": "Rate",
      "isDefault": "Default rate",
      "status": "Status",
      "category": "VAT return box"
    },
    "hints": {
      "rate": "A percentage with up to 2 decimals, from 0 to 100.",
      "default": "Suggested on new documents and expenses. Only one rate is the default.",
      "category": "How sales at this rate are reported. Standard rates are above 0%; zero-rated, exempt and out-of-scope rates are 0%."
    },
    "archive": {
      "title": "Archive {{name}}?",
      "body": "It can no longer be chosen. Documents that used it keep it.",
      "confirm": "Archive"
    },
    "errors": {
      "nameTaken": "A tax rate with this name already exists.",
      "version": "Someone else changed this rate. Close this panel and open it again."
    },
    "toast": {
      "created": "Tax rate created",
      "updated": "Tax rate saved",
      "archived": "Tax rate archived"
    },
    "impact": {
      "title": "Change {{name}}?",
      "newDocuments": "New documents use the new rate.",
      "posted": "Posted documents keep the rate they were posted with.",
      "vatReturn": "The VAT return groups by category.",
      "confirm": "Change tax rate"
    },
    "category": {
      "STANDARD": "Standard-rated",
      "ZERO": "Zero-rated",
      "EXEMPT": "Exempt",
      "OUT_OF_SCOPE": "Out of scope"
    }
  },
  "recurring": {
    "title": "Recurring expenses",
    "short": "Recurring",
    "subtitle": "Expenses that repeat, such as rent: each date becomes an expense, posted for you or waiting for your review.",
    "new": "New recurring expense",
    "newTitle": "New recurring expense",
    "newSubtitle": "Set up the expense once, and when it repeats.",
    "editTitle": "Edit {{name}}",
    "editSubtitle": "Changes apply to the dates to come; expenses already created stay as they are.",
    "endedTitle": "This recurring expense has ended",
    "back": "Back to the recurring expense",
    "save": "Save recurring expense",
    "makeRecurring": "Make this recurring",
    "fromRecurring": "Recurring: {{name}}",
    "review": "Review",
    "waiting_one": "{{n}} recurring expense is waiting for your review",
    "waiting_other": "{{n}} recurring expenses are waiting for your review",
    "needsAttention": "Needs attention",
    "pendingCount_one": "{{n}} waiting for review",
    "pendingCount_other": "{{n}} waiting for review",
    "nextOn": "Next on {{date}}",
    "endsOn": "On {{date}}",
    "endsAfter_one": "After {{n}} time",
    "endsAfter_other": "After {{n}} times",
    "noMore": "No more dates",
    "noOccurrences": "Nothing created yet. Each date appears here when it comes.",
    "searchPlaceholder": "Search name, description or payee",
    "searchLabel": "Search recurring expenses",
    "statusFilter": "Status",
    "scheduleText": "{{every}} {{on}}",
    "every": {
      "WEEKLY_one": "Weekly",
      "WEEKLY_other": "Every {{n}} weeks",
      "MONTHLY_one": "Monthly",
      "MONTHLY_other": "Every {{n}} months",
      "QUARTERLY_one": "Quarterly",
      "QUARTERLY_other": "Every {{n}} quarters",
      "YEARLY_one": "Yearly",
      "YEARLY_other": "Every {{n}} years"
    },
    "on": {
      "weekday": "on {{day}}",
      "day": "on day {{day}}",
      "lastDay": "on the last day",
      "date": "on {{date}}"
    },
    "unit": {
      "WEEKLY_one": "week",
      "WEEKLY_other": "weeks",
      "MONTHLY_one": "month",
      "MONTHLY_other": "months",
      "QUARTERLY_one": "quarter",
      "QUARTERLY_other": "quarters",
      "YEARLY_one": "year",
      "YEARLY_other": "years"
    },
    "frequency": {
      "WEEKLY": "Weekly",
      "MONTHLY": "Monthly",
      "QUARTERLY": "Quarterly",
      "YEARLY": "Yearly"
    },
    "status": {
      "ACTIVE": "Active",
      "PAUSED": "Paused",
      "ENDED": "Ended"
    },
    "occurrence": {
      "PENDING": "For review",
      "SKIPPED": "Skipped"
    },
    "sections": {
      "schedule": "Schedule",
      "scheduleHint": "When it repeats, and what happens on each date.",
      "amount": "Amount each time",
      "history": "Dates so far"
    },
    "fields": {
      "name": "Name",
      "frequency": "Repeats",
      "interval": "Every",
      "dayOfMonth": "On day",
      "lastDay": "Last day of the month",
      "startDate": "Starts on",
      "ends": "Ends",
      "endDate": "End date",
      "maxOccurrences": "Number of times",
      "mode": "On each date",
      "repeats": "Repeats",
      "next": "Next date",
      "eachTime": "Each time",
      "comingUp": "Coming up",
      "lastDate": "Last date"
    },
    "hints": {
      "name": "How it shows in lists, such as “Office rent”.",
      "dayOfMonth": "Months without this day use their last day.",
      "startLinked": "The expense’s date: it is the first one."
    },
    "ends": {
      "never": "Never",
      "date": "On a date",
      "count": "After a number of times"
    },
    "mode": {
      "review": "Wait for my review",
      "reviewHint": "Each date waits under Recurring until you post it (you can change the amount) or skip it.",
      "post": "Post automatically",
      "postHint": "Each date is recorded and posted as an expense from the account above."
    },
    "preview": {
      "title": "Next dates",
      "none": "No dates to come with this schedule.",
      "reviewNow_one": "Saving puts {{n}} date that has already passed up for review.",
      "reviewNow_other": "Saving puts {{n}} dates that have already passed up for review.",
      "postsNow_one": "Saving posts {{n}} expense for a date that has already passed.",
      "postsNow_other": "Saving posts {{n}} expenses for dates that have already passed."
    },
    "source": {
      "title": "Based on an expense",
      "label": "Count this expense as the first date:",
      "linked": "It stays as it is and starts the schedule on {{date}}; the dates after it follow.",
      "unlinked": "The expense stays apart; choose when the schedule starts."
    },
    "repeat": {
      "title": "Repeat",
      "label": "Repeat monthly",
      "hint": "Make this expense the first of a monthly recurring expense, each one waiting for your review.",
      "next": "Next on {{date}}, waiting for your review. Change the schedule under Recurring.",
      "failed": "{{number}} is saved, but it could not be set to repeat. Use “Make this recurring” on it."
    },
    "pending": {
      "title": "Waiting for review",
      "hint": "Post each one as an expense (you can change the amount first) or skip it."
    },
    "actions": {
      "edit": "Edit",
      "run": "Run now",
      "pause": "Pause",
      "resume": "Resume",
      "end": "End",
      "delete": "Delete",
      "post": "Post",
      "skip": "Skip"
    },
    "post": {
      "title": "Post {{name}}",
      "body": "This records the expense and posts it from the cash or bank account.",
      "confirm": "Post expense"
    },
    "skip": {
      "title": "Skip {{date}}?",
      "body": "No expense is recorded for this date. The schedule goes on.",
      "confirm": "Skip date"
    },
    "end": {
      "title": "End this recurring expense?",
      "body": "No more dates are created. Dates waiting for review stay, and expenses already created are kept.",
      "confirm": "End it"
    },
    "delete": {
      "title": "Delete this recurring expense?",
      "body": "Nothing was created from it yet, so it is removed for good.",
      "confirm": "Delete"
    },
    "lastError": {
      "title": "The last expense could not be created",
      "body": "The expense for {{date}} was refused on {{at}}. It is tried again every night; edit the recurring expense to fix it."
    },
    "conflict": {
      "title": "Someone else changed this recurring expense",
      "body": "Reload it to see their changes, then make yours again."
    },
    "empty": {
      "title": "No recurring expenses yet",
      "body": "Set up rent, subscriptions or any other expense that repeats, once.",
      "filteredTitle": "No recurring expenses match"
    },
    "toast": {
      "created": "{{name}} is set up",
      "updated": "Recurring expense saved",
      "deleted": "{{name}} deleted",
      "pause": "Paused",
      "resume": "Resumed",
      "end": "Ended",
      "run": "Done",
      "ranPosted": "The expense for {{date}} is posted",
      "ranReview": "The expense for {{date}} is waiting for your review",
      "posted": "{{number}} posted",
      "skipped": "Date skipped"
    },
    "errors": {
      "RECURRING_ENDED": "This recurring expense has ended: it can no longer be changed or run.",
      "RECURRING_PAUSED": "This recurring expense is paused. Resume it first.",
      "RECURRING_NOT_PAUSED": "Only a paused recurring expense can be resumed.",
      "IN_USE": "Expenses were created from it, so it can’t be deleted. End it instead."
    }
  }
}
